/*=========================================================================================
  File Name: state.js
  Namespace: sonar
  Description: Vuex Store - Sonar state
==========================================================================================*/

const SONAR_POSSIBLE_STATUS = {
  DRAFT: 'draft',
  PUBLISHED: 'published',
  ARCHIVED: 'archived',
  COMMING_SOON: 'coming_soon',
}

export const buildSonarState = () => {
  return {
    id: null,
    SkillArea: {
      name: '',
      id: null,
      areaStatus: null,
      Assessments: [],
      category: null,
      is_beta: false,
    },
    LearningAreaGroup: {
      name: '',
      id: null
    },
    LearningArea: {
      name: '',
      id: null
    },
    created: null,
    modified: null,
    type: 'sonar',
    summary: [],
  }
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  currentSonar: buildSonarState(),
  sonarList: null,
  count: 0,
  next: null,
  previous: null,
  results: [],
  SONAR_POSSIBLE_STATUS,
}

export default state